import { type IAdvancedRichText } from '../IAdvancedRichText.ts';

export function toAdvancedRichText(
  input: string | IAdvancedRichText | undefined,
): IAdvancedRichText {
  if (!input) return [];

  if (typeof input === 'string') return [{ text: input, type: 'text' }];
  return input;
}
